import AppLayout from '@/components/AppLayout';
import AccountLayout from '@/components/AccountLayout';

export default function AccountPage() {
  return (
    <AppLayout>
      <AccountLayout />
    </AppLayout>
  );
}
